import Image from 'next/image';

import { Box } from '@/components/Box';
import type { CardProps } from '@/components/Cms/Card';
import { Heading } from '@/components/Cms/Heading';
import { Typography } from '@/components/Typography';
import type { ContentfulHeadingFragment } from '@/graphql/contentful/api';

import * as S from './Contact.styles';

interface ContactProps {
  contentfulData: CardProps | undefined;
  email?: string;
  onClick: () => void;
  phoneNumber?: string;
}
export const Contact = ({
  contentfulData,
  email,
  onClick,
  phoneNumber,
}: ContactProps) => {
  const { id } = contentfulData!;

  const emailSubText =
    contentfulData?.cardText?.json.content[0]?.content[0]?.value;

  const sanitizedEmailSubText = emailSubText?.replace('%{{contact.email}}', '');

  return (
    <S.Container
      backgroundImage={contentfulData?.media?.image?.url}
      id={id ?? ''}
      onClick={onClick}
    >
      <S.IconWrapper>
        {contentfulData?.icon?.url && (
          <Image
            alt={contentfulData.icon.title as string}
            layout='fill'
            src={contentfulData.icon.url}
          />
        )}
      </S.IconWrapper>
      <S.HeaderWrapper>
        {contentfulData?.placeholderHeading && (
          <Heading
            Heading={
              contentfulData?.placeholderHeading as ContentfulHeadingFragment
            }
            data-test-id='ContactUsHeading'
            sizeDesktop={34}
            sizeMobile={28}
          />
        )}
        <Typography color='white' paddingX='s100' scale='p2' textAlign='center'>
          {contentfulData?.subHeading}
        </Typography>
      </S.HeaderWrapper>
      {sanitizedEmailSubText && (
        <S.TextGroup>
          <Box>
            <Typography color='white' scale='p2' textAlign='center'>
              {sanitizedEmailSubText} {email}
            </Typography>
          </Box>
        </S.TextGroup>
      )}
      {phoneNumber && (
        <S.TextGroup>
          <Box>
            <Typography
              color='white'
              scale='p2'
              textAlign='center'
              textDecoration='underline'
              textTransform='uppercase'
            >
              {phoneNumber}
            </Typography>
          </Box>
        </S.TextGroup>
      )}
    </S.Container>
  );
};
